import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  ResendVerificationCodeInput,
  ResendVerificationCodeResponse,
  resendVerifictionCodeResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIResendVerificationCode = (
  options?: UseMutationOptions<
    ResendVerificationCodeResponse,
    ErrorResponse,
    ResendVerificationCodeInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.RESEND_VERIFICATION_CODE,
        data,
        resendVerifictionCodeResponseSchema
      ),
    ...options,
  })
